var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('v-btn',{staticClass:"subtitle black--text",staticStyle:{"position":"fixed","left":"10px","top":"10px","z-index":"1"},attrs:{"icon":"","large":""},on:{"click":_vm.goToHome}},[_vm._v(" Back ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }